import { jsx } from "@emotion/react/jsx-runtime";
import { useDeepMemo } from "./auth-service-tools30.js";

const useExtraFields = (definition, register) => {
  const entries = useDeepMemo(() => Object.entries(definition || {}), [definition]);
  return entries.map((_ref) => {
    let [key, value] = _ref;
    return /* @__PURE__ */jsx("input", {
      type: "hidden",
      value,
      ...register(key)
    }, key);
  });
};

export { useExtraFields };